class CartPrivacyConsent extends HTMLElement {
  connectedCallback() {
    this.checkbox = this.querySelector('input[type="checkbox"]');
    this.error = this.querySelector('.cart-privacy-consent__error');
    this.checkoutButtonId = this.dataset.checkoutButton;
    this.formId = this.dataset.formId;

    if (!this.checkbox) return;

    this.onChange = () => this.updateState();
    this.onSubmit = (event) => this.handleSubmit(event);
    this.onCheckoutClick = (event) => this.handleCheckoutClick(event);

    this.checkbox.addEventListener('change', this.onChange);

    this.form = document.getElementById(this.formId);
    if (this.form) {
      this.form.addEventListener('submit', this.onSubmit);
    }

    this.bindCheckoutButtons();
    this.updateState();
  }

  disconnectedCallback() {
    this.checkbox?.removeEventListener('change', this.onChange);
    this.form?.removeEventListener('submit', this.onSubmit);
    this.checkoutButtons?.forEach((button) => {
      button.removeEventListener('click', this.onCheckoutClick);
    });
  }

  bindCheckoutButtons() {
    this.checkoutButtons = this.getCheckoutButtons();
    this.checkoutButtons.forEach((button) => {
      button.addEventListener('click', this.onCheckoutClick);
    });
  }

  getCheckoutButtons() {
    const buttons = [];
    const checkoutButton = document.getElementById(this.checkoutButtonId);

    if (checkoutButton) {
      buttons.push(checkoutButton);
    }

    if (this.form) {
      this.form.querySelectorAll('[name="checkout"]').forEach((button) => {
        if (!buttons.includes(button)) {
          buttons.push(button);
        }
      });
    }

    return buttons;
  }

  isConsented() {
    return this.checkbox.checked;
  }

  updateState() {
    const disabled = !this.isConsented();

    this.checkoutButtons.forEach((button) => {
      button.disabled = disabled;
      button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    });

    const dynamicCheckout = this.closest('.drawer__footer, .cart-summary-area')
      ?.querySelector('.cart__dynamic-checkout-buttons');

    if (dynamicCheckout) {
      dynamicCheckout.classList.toggle('cart-privacy-consent--blocked', disabled);
    }

    if (this.isConsented() && this.error) {
      this.error.classList.add('hidden');
    }
  }

  handleSubmit(event) {
    const submitter = event.submitter;

    if (submitter?.name === 'checkout' && !this.isConsented()) {
      event.preventDefault();
      this.showError();
    }
  }

  handleCheckoutClick(event) {
    if (this.isConsented()) return;

    event.preventDefault();
    this.showError();
  }

  showError() {
    this.error?.classList.remove('hidden');
    this.checkbox.focus();
  }
}

customElements.define('cart-privacy-consent', CartPrivacyConsent);
